module.exports = __webpack_public_path__ + "img/Pythagoras_Borghese.d11172ed.png";